import React from "react";
import PersonDark from "../assets/PersonDark.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const RoomTypeDetails = () => {
  const { t } = useTranslation();

  return (
    <div className="room-search-details-sec mt-md-5 mb-md-5 mt-4 mb-4">
      <div className="container">
        <div className="comon-box-search-details-top">
          {/* First Room Box */}
          <div className="inner-room-search-details d-flex flex-wrap">
            <div className="room-box-search">
              <div className="row-header">
                <h5>{t("roomType1")}</h5>
              </div>
              <div className="row-bottom">
                <h4>{t("deluxeKingSuite")}</h4>
                <ul className="box-two d-flex justify-content-between gap-3 list-unstyled p-0 m-0">
                  <li>{t("roomFeatures1")}</li>
                  <li>{t("roomFeatures2")}</li>
                </ul>
              </div>
              <div className="row-bottom">
                <p>{t("roomAmenities")}</p>
              </div>
            </div>

            <div className="room-box-search">
              <div className="row-header">
                <h5>{t("numberOfGuests")}</h5>
              </div>
              <div className="row-bottom">
                <div className="img-review d-flex align-items-center gap-2">
                  <img src={PersonDark} alt="guest" />
                  <h4>1+1</h4>
                </div>
              </div>
            </div>

            <div className="room-box-search">
              <div className="row-header">
                <h5>{t("priceForNights", { nights: 3 })}</h5>
              </div>
              <div className="row-bottom">
                <h4>₹ 7,840</h4>
                <ul className="box-two d-flex justify-content-between flex-wrap list-unstyled p-0 m-0">
                  <li className="w-100">{t("originalPrice")}</li>
                  <li className="w-100">+₹ 941 {t("taxesAndFees")}</li>
                </ul>
              </div>
            </div>

            <div className="room-box-search fooms-bottom-color-box">
              <div className="row-header">
                <h5>{t("priceForNights", { nights: 3 })}</h5>
              </div>
              <div className="row-bottom d-flex flex-column">
                <ul className="color-green-box">
                  <li>{t("breakfastIncluded1")}</li>
                  <li>{t("freeCancellation")}</li>
                  <li>{t("noPrepayment")}</li>
                  <li>{t("noCreditCard")}</li>
                </ul>
                <ul className="color-red-box mt-auto">
                  <li>{t("quickBooking")}</li>
                  <li>{t("noChargeNextStep")}</li>
                </ul>
              </div>
            </div>

            <div className="full-box-total-bottom w-100 d-flex align-items-center justify-content-between gap-2">
              <div className="left-total d-flex align-items-center gap-2">
                <h5 className="m-0 p-0 text-nowrap ">
                  {t("selectRooms")}
                </h5>
                <select className="form-select pe-5 ps-3">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                </select>
              </div>
              <div className="right-total">
                <Link to="/mybooking" className="btn btn-box btn-orange">
                  {t("reserveNow")}
                </Link>
              </div>
            </div>
          </div>

          {/* Second Room Box */}
          <div className="inner-room-search-details d-flex flex-wrap">
            <div className="room-box-search">
              <div className="row-bottom">
                <h4>{t("deluxeKingSuite")}</h4>
                <ul className="box-two d-flex justify-content-between gap-3 list-unstyled p-0 m-0">
                  <li>{t("roomFeatures1")}</li>
                  <li>{t("roomFeatures2")}</li>
                </ul>
              </div>
              <div className="row-bottom">
                <p>{t("roomAmenities")}</p>
              </div>
            </div>

            <div className="room-box-search">
              <div className="row-bottom">
                <div className="img-review d-flex align-items-center gap-2">
                  <img src={PersonDark} alt="guest" />
                  <h4>1+1</h4>
                </div>
              </div>
            </div>

            <div className="room-box-search">
              <div className="row-bottom">
                <h4>₹ 7,840</h4>
                <ul className="box-two d-flex justify-content-between gap-3 flex-wrap list-unstyled p-0 m-0">
                  <li className="w-100">{t("originalPrice")}</li>
                  <li className="w-100">+₹ 941 {t("taxesAndFees")}</li>
                </ul>
              </div>
            </div>

            <div className="room-box-search fooms-bottom-color-box">
              <div className="row-bottom d-flex flex-column">
                <ul className="color-green-box m-0 pb-0">
                  <li>{t("breakfastIncluded1")}</li>
                  <li>{t("freeCancellation")}</li>
                  <li>{t("noPrepayment")}</li>
                  <li>{t("noCreditCard")}</li>
                </ul>
                <ul className="color-red-box mt-auto mb-0 pb-0">
                  <li>{t("quickBooking")}</li>
                  <li>{t("noChargeNextStep")}</li>
                </ul>
              </div>
            </div>

            <div className="full-box-total-bottom w-100 d-flex align-items-center justify-content-between gap-2">
              <div className="left-total d-flex align-items-center gap-2">
                <h5 className="m-0 p-0 text-nowrap ">
                  {t("selectRooms")}
                </h5>
                <select className="form-select pe-5 ps-3">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                </select>
              </div>
              <div className="right-total">
                <Link to="/mybooking" className="btn btn-box btn-orange">
                  {t("reserveNow")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomTypeDetails;
